import { signOut } from 'firebase/auth';
import { auth } from '../lib/firebase';
import { clearUserSession } from './authStorage';

export async function logout() {
  try {
    clearUserSession();
    await signOut(auth);
  } catch (error) {
    console.error('Failed to clear auth storage', error);
  } finally {
    window.location.replace('/login');
  }
}
